module.exports = __webpack_public_path__ + "static/media/m_beard_tailored_diamond__v.5a71417e.png";